exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map-general{height:100%;max-height:400px;min-height:400px;max-width:400px;margin:0}.selectable:hover{cursor:pointer;background:#e0e0e0}", ""]);

// exports
